<template>
  <div>
    <v-dialog v-model="dialog" persistent max-width="600px">
      <template v-slot:activator="{ on, attrs }">
        <v-icon size="24px" v-bind="attrs" v-on="on" @click="setData">mdi-magnify</v-icon>
      </template>
      <v-card>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col>
                <div class="d-flex justify-space-between align-center">
                  <span class="headline grey--text text--darken-4">Novo CMS</span>
                  <v-icon size="24px" class="pointer" @click="dialog = false">
                    mdi-close
                  </v-icon>
                </div>
              </v-col>
              <v-col cols="12" class="green darken-2 pa-5 text-center" v-if="this.cms.is_authorized">
                <span
                  class="white--text"
                >CMS autorizado pelo usuário com sucesso</span>
              </v-col>
              <v-col cols="12" class="red lighten-1 pa-5 text-center d-flex justify-space-between" v-else>
                <span
                  class="white--text"
                >CMS ainda não autorizado pelo usuário</span>
                <span class="white--text pointer" @click="authChannel(cms.id_youtube_cms)">Reenviar Pedido</span>
              </v-col>
            </v-row>
             <v-form
              ref="form"
              v-model="valid"
            >
              <v-row>
                <v-col cols="12">
                  <v-text-field label="Nome do CMS" v-model="name" :rules="[rules.required]"></v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-text-field label="ID do CMS (Content Owner ID)" v-model="cmsIdYoutube" :rules="[rules.required]"></v-text-field>
                </v-col>
              </v-row>
            </v-form>
          </v-container>
        </v-card-text>
        <v-card-actions class="d-flex justify-center flex-wrap align-center">
          <v-spacer class="d-none d-md-block"></v-spacer>
          <v-btn
            v-if="!deleteConfirm"
            color="#ef5350"
            class="button-primary mb-4"
            @click="deleteConfirm = true"
            dark
          >
            <span>Excluir CMS</span>
          </v-btn>
          <v-btn v-else color="#ef5350" class="mb-4" @click="deleteCms()" dark>
            <span>CONFIRMAR EXCLUSÃO</span>
          </v-btn>
          <v-btn
            :disabled="!valid"
            color="#fed602"
            @click="updateCms()"
            class="button-primary mb-4 mr-2"
          >
            <v-progress-circular v-if="loading" :indeterminate="true" size="24"></v-progress-circular>
            <span v-else>Salvar</span>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  props: {
    cms: {
      type: Object,
      required: true,
      default: null,
    }
  },
  created() {
    this.setData();
  },
  data: () => ({
    name: '',
    cmsIdYoutube: '',
    deleteConfirm: false,
    loading: false,
    notification: {
        active: false,
        description: '',
        type: '',
        closeText: ''
    },
    valid: true,
    rules: {
        required: value => !!value || 'Este campo é obrigatório.',
        min: v => v.length >= 6 || 'Sua senha precisa ter pelo menos 6 caracteres',
        email: v => /.+@.+\..+/.test(v) || 'E-mail inválido'
    },
    dialog: false
  }),
  methods: {
    authChannel(cms) {
      this.$http.post( '/youtube-auth', {
        id_youtube_cms: cms,
      })
      .then( (res) => {
        window.open(res.data.url, "authwindow", "height=580,width=620")
      })
    },
    setData() {
      this.name = this.cms.name; 
      this.cmsIdYoutube = this.cms.cms_id_youtube
    },
    updateCms() {
      this.$http.put( '/cms/' + this.cms.id_youtube_cms, {
        name: this.name,
        cms_id_youtube: this.cmsIdYoutube,
      })
      .then( () => {
        this.notification = {
          active: true,
          description: 'CMS editado com sucesso.',
          type: 'success',
          closeText: 'Fechar'
        },
        this.$emit( 'notification', this.notification );
      })
      .catch(() => {
        (this.notification = {
          active: true,
          description: "Houve um erro ao editar este CMS, tente novamente.",
          type: "error",
          closeText: "Fechar",
        }),
          this.$emit("notification", this.notification);
      })
      .finally(() => {
        (this.loading = false),
          (this.valid = true),
          (this.dialog = false),
          (this.deleteConfirm = false),
          this.$emit("getData");
      });
    },
    deleteCms() {
      this.$http
        .delete("/cms/" + this.cms.id_youtube_cms)
        .then(() => {
          (this.notification = {
            active: true,
            description: "CMS excluído com sucesso.",
            type: "success",
            closeText: "Fechar",
          }),
            this.$emit("notification", this.notification);
        })
        .catch(() => {
          (this.notification = {
            active: true,
            description: "Houve um erro ao excluir este CMS, tente novamente.",
            type: "error",
            closeText: "Fechar",
          }),
            this.$emit("notification", this.notification);
        })
        .finally(() => {
          (this.loading = false),
            (this.valid = true),
            (this.dialog = false),
            (this.deleteConfirm = false),
            this.$emit("getData");
        });
    }
  }
}
</script>